import { createFileRoute } from "@tanstack/react-router";
import { CargaInvoicePage } from "@/features/carga-invoice/components/CargaInvoicePage";
import { solicitudQueryOptions } from "@/features/solicitudes/hooks/use-solicitud";
import { ErrorAlert } from "@/components/ui";

export const Route = createFileRoute("/_authed-tw/solicitudes/$id/carga-invoice")({
  loader: ({ context: { queryClient }, params: { id } }) => queryClient.ensureQueryData(solicitudQueryOptions(id)),
  component: CargaInvoicePage,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
